const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Header cart badge (2026-09): the badge is rendered server-side from
   cart.item_count, so a cached page — Shopify's full-page cache, or the
   browser's back/forward cache — can show a stale or missing count. Re-sync it
   from /cart.js on every load and on bfcache restore. Fails silently. */
(function () {
  function syncCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var n = cart.item_count;
        document.querySelectorAll('.stk-h__cart-count, .cart-count').forEach(function (el) {
          el.textContent = n;
          el.classList.toggle('is-hidden', n === 0);
        });
        document.querySelectorAll('.stk-h__cart').forEach(function (a) {
          a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCartCount(); });

  /* Other scripts (product page, tutorial parts box) update the number directly
     after an add — keep the link's accessible label in step with it. */
  document.addEventListener('DOMContentLoaded', function () {
    var badge = document.querySelector('.stk-h__cart-count');
    var link = document.querySelector('.stk-h__cart');
    if (!badge || !link || !window.MutationObserver) return;
    new MutationObserver(function () {
      var n = parseInt(badge.textContent, 10);
      if (isNaN(n)) return;
      link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  });
})();
